import { Box, Button, Tag, TagColor } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import {
  ReconciliationSource,
  ReconciliationStatusEnum,
} from 'modules/finance/components/ReconciliationForm/types'

interface TagLabelComponentProps {
  source?: ReconciliationSource | null
  dirty: boolean
  onReconcile: () => void
}

export const TagLabelComponent = ({ source, dirty, onReconcile }: TagLabelComponentProps) => {
  const tagLabel = () => {
    switch (source?.reconciliationStatus) {
      case ReconciliationStatusEnum.Partial:
        return i18n.t('finance.reconciliations.total_summary.status.partially_reconciled')
      case ReconciliationStatusEnum.Full:
        return i18n.t('finance.reconciliations.total_summary.status.full_reconciled')
      default:
        return ''
    }
  }

  const tagColor = () => {
    switch (source?.reconciliationStatus) {
      case ReconciliationStatusEnum.Partial:
        return TagColor.champagne
      case ReconciliationStatusEnum.Full:
        return TagColor.lime
      default:
        return TagColor.neutral
    }
  }

  return (
    <Box width="full" paddingX="s8">
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Box>
          {source && source.reconciliationStatus !== ReconciliationStatusEnum.None && (
            <Tag showCircle type={tagColor()} leftItem="circle" inline>
              {tagLabel()}
            </Tag>
          )}
        </Box>
        <Box>
          {source && (
            <Button disabled={!dirty} onClick={onReconcile}>
              {i18n.t('finance.reconciliations.total_summary.reconcile')}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  )
}
